import React from "react";

interface GreyCardProps {
  children: React.ReactNode;
}

const GreyCard: React.FC<GreyCardProps> = ({ children }) => {
  return (
    <div className="w-full h-full p-4 bg-[#eaebf0] rounded-[36px] border flex-col justify-center  mt-3 gap-4 inline-flex mx-auto">
      <div className="self-stretch h-full p-2 bg-white rounded-3xl flex justify-center  gap-10 flex">
        {children}
      </div>
    </div>
  );
};

export default GreyCard;
